import { AiHelpSuggestion } from '../models/ai-help-assistant.models';

/** Default starter prompts — extend or override per route via context service later. */
export const DEFAULT_AI_HELP_SUGGESTIONS: AiHelpSuggestion[] = [
  {
    id: 'timesheet',
    label: 'How do I log time on a timesheet?',
    prompt: 'How do I log time on a timesheet?',
    icon: 'timer'
  },
  {
    id: 'projects',
    label: 'How do I find my assigned projects?',
    prompt: 'How do I find my assigned projects?',
    icon: 'folder_open'
  },
  {
    id: 'tasks',
    label: 'How do I update a task status?',
    prompt: 'How do I update a task status?',
    icon: 'task_alt'
  },
  {
    id: 'approvals',
    label: 'Where do I approve timesheets?',
    prompt: 'Where do I approve timesheets?',
    icon: 'fact_check'
  }
];
